/**
 * CleanlinessVisual.js
 * 
 * Displays the visual for the Cleanliness section.
 * Extracted from legacy MainRight.js logic using IlAdd active="cl".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const CleanlinessVisual = ({ lower }) => {
  if (lower === "left") {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/cleanliness/cleanliness-left.jpeg")`}}></div>);		
  } else if (lower === "right") {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/cleanliness/cleanliness-right.jpeg")`}}></div>);		
  } else {
    // Default or "upper" case
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/cleanliness/cleanliness-upper.jpeg")`}}></div>);
  }
};
